import { DynForm } from 'src/app/_model/dyn-form';
import { PostProcessor } from '../post-processor';
import { PostProcessorService } from '../post-processors.service';
import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { PostProcessorXML } from 'src/app/_model/dyn-form/dyn-form-xml';
import { IMSObject, IMSObjectType } from 'src/app/_model/ims-object';
import { RemoteActionUpdateObject } from 'src/app/_model/remote-action/remote-action-builder/remote-action-builder';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { LBSUtils } from 'src/app/_util/lbs-utils';

@Injectable({
  providedIn: 'root',
})
export class GeneralPostProcessorService implements PostProcessorService {
  constructor(
    private postProcessors: PostProcessor,
    private logger?: LoggingService,
  ) {}

  public async handlePostProcessors(
    form: DynForm,
    formData: any,
    imsObject: IMSObject,
    remoteAction: RemoteAction,
  ): Promise<RemoteActionUpdateObject[]> {
    if (form == undefined || formData == undefined) {
      this.logger.log(
        this.constructor.name,
        'Form or formData is not defined, aborting handlePostProcessor call... form:',
        form,
        ' formdata:',
        formData,
      );
      return undefined;
    }

    let postProcessors = form.form.form?.postprocessors;

    const updateObjects: RemoteActionUpdateObject[] = [];
    if (postProcessors?.postprocessor) {
      this.logger.log(
        this.constructor.name,
        'PostProcessors xml has at least 1 post processor in it ',
        form.form.form.postprocessors.postprocessor,
      );
      const updateObject = await this.iterateOverPostProcessorsArray(
        postProcessors.postprocessor instanceof Array
          ? postProcessors.postprocessor
          : [postProcessors.postprocessor],
        form,
        formData,
        imsObject,
        remoteAction,
      );
      if (updateObject != undefined) {
        updateObjects.push(...updateObject);
      }
    }

    this.logger.log(this.constructor.name, 'process formfield postprocessors');
    for (const pp of LBSUtils.getArrayOfOptionalArray(this.postProcessors)) {
      this.logger.log(
        this.constructor.name,
        'found pp',
        pp.name,
        formData[pp.name],
      );
      if (formData[pp.name]) {
        this.logger.log(
          this.constructor.name,
          'found a pp with formpi set',
          formData[pp.name],
        );
        const updateObject = await pp.postProcess(form, formData, imsObject, undefined, remoteAction);
        if (updateObject != undefined) {
          updateObjects.push(...updateObject);
        }
      }
    }
    return updateObjects;
  }

  private async iterateOverPostProcessorsArray(
    postProcessorArray: PostProcessorXML[],
    form: DynForm,
    formData: any,
    imsObject: IMSObject,
    remoteAction: RemoteAction,
  ): Promise<RemoteActionUpdateObject[]> {
    if (postProcessorArray == undefined || postProcessorArray.length == 0) {
      this.logger.log(
        this.constructor.name,
        'PostProcessorArray is undefined or empty, skipping post processing... postprocessorArray:',
        postProcessorArray,
      );
      return undefined;
    }

    const updateObjects: RemoteActionUpdateObject[] = [];
    for (const postprocessor of postProcessorArray) {
      if (this.postProcessors instanceof Array) {
        for (const definedpostprocessor of this.postProcessors) {
          if (definedpostprocessor.name == postprocessor?.$?.type?.toString()) {
            this.logger.log(
              this.constructor.name,
              'Found postprocessor:',
              definedpostprocessor.name,
              ', executing postProcess of the post processor',
            );
            const updateObject = await definedpostprocessor.postProcess(
              form,
              formData,
              imsObject,
              postprocessor,
              remoteAction,
            );
            if (updateObject != undefined) {
              updateObjects.push(...updateObject);
            }
          }
        }
      }
    }
    return updateObjects;
  }
}
